import React from 'react'
import './PremiumTournamentModal.css'

const PremiumTournamentModal = ({ isOpen, onClose, onUpgradeToPremium, isGuest = false }) => {
  if (!isOpen) return null

  return (
    <div className="premium-tournament-modal-overlay" onClick={onClose}>
      <div className="premium-tournament-modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="premium-tournament-modal-header">
          <h2>Premium Required for Tournaments</h2>
          <button className="premium-tournament-modal-close" onClick={onClose}>×</button>
        </div>

        <div className="premium-tournament-modal-body">
          <div className="premium-icon">
            <span className="premium-star">★</span>
          </div>

          <p className="premium-message">
            Tournament access is exclusive to RiftChess Premium subscribers.
          </p>

          <p>Upgrade to Premium to unlock:</p>
          <ul className="premium-benefits">
            <li>Access to all tournaments</li>
            <li>Premium themes & pieces</li>
            <li>VIP badge and status</li>
            <li>Unlimited match history</li>
          </ul>

          <div className="premium-pricing">
            <div className="pricing-highlight">
              <span className="price">Starting at $7/month</span>
              <span className="savings">or $70/year (Save $14)</span>
            </div>
          </div>
        </div>

        <div className="premium-tournament-modal-footer">
          <button className="premium-tournament-modal-cancel" onClick={onClose}>
            Maybe Later
          </button>
          <button
            className="premium-tournament-modal-upgrade"
            onClick={onUpgradeToPremium}
            disabled={isGuest}
            title={isGuest ? "Please create a regular account to upgrade to premium" : ""}
          >
            Upgrade to Premium ★
          </button>
        </div>
      </div>
    </div>
  )
}

export default PremiumTournamentModal